<template>
  <div class="trbo-a-search-box">
    <input v-model="value" class="trbo-a-search-box__input" aria-label="Search" :placeholder="$t('wizard.searchFor')" @keyup.enter="submitSearch">
    <div class="trbo-a-search-box__button" @click="onSubmitClear">
      <icon v-if="!isSubmitted" name="search" />
      <icon v-else name="close" />
    </div>
  </div>
</template>

<script>
// @flow

import Icon from '../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  props: {
    initialValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: '',
      isSubmitted: false
    }
  },
  watch: {
    value (newValue: string): void {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => this.submitSearch(), 500)
    },
    initialValue (newValue: string): void {
      if (this.value === newValue) return
      this.value = newValue
      this.isSubmitted = false
    }
  },
  destroyed (): void {
    clearTimeout(this.interval)
  },
  created () {
    this.value = this.initialValue
  },
  methods: {
    submitSearch (): void {
      this.isSubmitted = !!this.value
      this.$emit('search', this.value)
    },
    onSubmitClear (): void {
      clearTimeout(this.interval)
      if (this.isSubmitted) {
        this.value = ''
        this.isSubmitted = false
      } else if (this.value) {
        this.isSubmitted = true
      }
      this.submitSearch()
    }
  }
}
</script>

<style scoped src="./search-box.scss" />
